import { css, cx } from "@emotion/css"

import { ColorVariant } from "utils/color"
import { ReactNode } from "react"

const styles = {
  root: css`
    display: inline-flex;
    align-items: center;
    padding: 0.125rem var(--spacing-xs);
    border-radius: 0.125rem;
    margin-left: var(--spacing-xs);
    max-width: 11rem;
    height: var(--spacing-m);
    text-transform: uppercase;
    line-height: 1;
    text-align: center;
    .text {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  `,
  colors: {
    default: css`
      background-color: var(--grey);
    `,
    info: css`
      background-color: var(--black);
    `,
    success: css`
      background-color: var(--primary-main);
    `,
    live: css`
      background-color: var(--secondary-light-blue);
    `,
    approved: css`
      color: #fff;
      background-color: var(--primary-main);
    `,
    warning: css`
      background-color: var(--tertiary-light-yellow);
    `,
    error: css`
      background-color: var(--red);
    `,
    new: css`
      background-color: var(--secondary-dark-blue-2);
    `,
    partial: css`
      background-color: var(--purple);
    `,
    warningAlt: css`
      background-color: var(--secondary-light-orange);
    `,
    darkPurple: css`
      background-color: var(--tertiary-dark-purple);
    `,
    lightBlue: css`
      background-color: var(--tertiary-light-blue);
    `,
  },
}

type BadgeProps = {
  children: ReactNode
  className?: string
  color?: ColorVariant
}

function Badge({ children, className, color = "default" }: BadgeProps) {
  const cn = cx(
    "BodyBody-xsWhiteRegular",
    styles.root,
    styles.colors[color],
    className,
  )

  return children ? (
    <div className={cn}>
      <span data-testid="badge" className="text">
        {children}
      </span>
    </div>
  ) : null
}

export default Badge
